import type { Shema } from '../api/odjemalec';

type Vozilo = Shema['VoziloPodatki'];

/** Oznaka stanja vozila za sezname (na zalogi = brez oznake), kot ga določajo podatki s strežnika. */
export function stanjeVozila(v: Vozilo): { naziv: string; barva: string } | null {
  if (v.datumRazgradnje) {
    return { naziv: 'razgrajeno', barva: 'gray' };
  }
  if (v.datumVracila) {
    return { naziv: 'vrnjeno', barva: 'gray' };
  }
  if (v.financirano) {
    // prodano leasing hiši, vozilo je še pri podjetju (do odkupa)
    return { naziv: 'financirano (leasing)', barva: 'orange' };
  }
  if (v.prodanaCena) {
    return { naziv: 'prodano', barva: 'green' };
  }
  return null;
}

/** »Škoda Octavia« ali »Vozilo«. */
export function nazivVozila(v?: Vozilo): string {
  return [v?.znamka, v?.tip].filter(Boolean).join(' ') || 'Vozilo';
}

/** Število iz Mantine NumberInput (prazno → null). */
export function stevilo(v: number | string | undefined | null): number | null {
  if (v === '' || v === undefined || v === null) {
    return null;
  }
  const n = typeof v === 'number' ? v : Number(String(v).replace(',', '.'));
  return Number.isFinite(n) ? n : null;
}
